import { css } from "@emotion/css";
import React from "react";
import { Subject } from "rxjs";
import {
  combineLatestWith,
  distinctUntilChanged,
  filter,
  map,
  scan,
} from "rxjs/operators";

const rawDestinations$ = new Subject<HTMLDivElement | null>();

export const destinations$ = rawDestinations$.pipe(
  filter((e): e is HTMLDivElement => e !== null)
);

export function Placeholder({ height }) {
  return (
    <div
      className={css`
        border: 1px solid blue;
        background-color: rgba(21, 101, 192, 0.239);
        border-radius: 8px;
        height: ${height};
      `}
      ref={(r) => rawDestinations$.next(r)}
    ></div>
  );
}
